import { getWebSocketBaseUrl } from '../utils/api';

/**
 * Hook to generate WebSocket URLs for thread-specific connections
 * 
 * @param {string} workspaceId - The ID of the workspace
 * @param {string} threadId - The ID of the thread
 * @param {string} agentType - The type of agent
 * @returns {string} WebSocket URL for the specified workspace, thread and agent
 */
const useWebSocketThreadUrl = (workspaceId, threadId, agentType) => {
  // Only generate URLs if we have required IDs
  if (!workspaceId || !threadId) {
    return null;
  }

  const baseUrl = getWebSocketBaseUrl();

  return `${baseUrl}/workspaces/${workspaceId}/threads/${threadId}/event?agent_type=${agentType}`;
};

export default useWebSocketThreadUrl;
